module.exports = __webpack_public_path__ + "static/media/features-split-top-01.91279f27.png";